// extracted by mini-css-extract-plugin
export var allCoursesButton = "pricingCourses-module--allCoursesButton--HIH7S";
export var buttonContainer = "pricingCourses-module--buttonContainer--ZAdjd";
export var cardContainer = "pricingCourses-module--cardContainer---OlVP";
export var cardWrapper = "pricingCourses-module--cardWrapper--zSdVg";
export var content = "pricingCourses-module--content--1rk3x";
export var edu = "pricingCourses-module--edu--WDscd";
export var enterprise = "pricingCourses-module--enterprise--z6BEd";
export var price = "pricingCourses-module--price--xzi93";
export var sbShowMain = "pricingCourses-module--sb-show-main--Zt7Rb";
export var title = "pricingCourses-module--title--+aHx1";
export var work = "pricingCourses-module--work--90whZ";